import BrowserCallNative from './BrowserCallNative.js';
import { getTft } from './tftInit.js';

export default class TianFuTongCallNative extends BrowserCallNative {
  static callNative(name, data) {
    if (!this[name]) {
      return Promise.reject(new Error(`${name}功能在天府通App中暂时无法使用`));
    }
    return this[name](data);
  }

  static closeWebView() {
    return getTft().closeWebView();
  }
}
